import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { BrigadesService } from '../../brigades.service';
import { Enums } from '../../../../../../../configs/Enums';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-remove-user-from-brigade',
  templateUrl: './remove-user-from-brigade.component.html',
  styleUrls: ['./remove-user-from-brigade.component.scss'],
  standalone: false,
})
export class RemoveUserFromBrigadeComponent implements OnInit {
  public brigadeHeadListInBrigade;
  public brigadeHeadNewSelected;
  public removeUserFromBrigadeLoading = false;
  public errorMessage = null;
  public errorMessageCode = Enums.errorCodesMaps['BACKEND_ERROR'];
  public currentBrigade;
  public sector;
  public user;

  constructor(
    public activeModal: NgbActiveModal,
    private brigadesService: BrigadesService
  ) {}

  ngOnInit() {
    this.brigadeHeadListInBrigade = this.brigadeHeadListInBrigade.map((worker) => {
      worker.full_name = worker.employee.full_name;
      return worker;
    });
  }

  public onChangeSelectedNewBrigadeHead(selected) {
    this.brigadeHeadNewSelected = selected;
  }

  public onRemoveUserFromBrigade() {
    this.removeUserFromBrigadeLoading = true;
    this.brigadesService
      .removeUserFromBrigade(this.currentBrigade.id, {
        new_head: this.brigadeHeadNewSelected.u_id,
        mounter: this.currentBrigade.brigade_head.u_id,
      })
      .subscribe(
        (response) => {
          this.removeUserFromBrigadeLoading = false;
          this.activeModal.close();
        },
        (error) => {
          this.errorMessage = Enums.errorCodes[this.errorMessageCode];
          this.removeUserFromBrigadeLoading = false;
        }
      );
  }
}
